<template>
  <div class="floorplan">
    <div class="floorplan__content">
      <SectionHeader>Floorplan</SectionHeader>

      <div class="floorplan__container">
        <div 
          class="floorplan__plans josh-js"
          data-josh-anim-name="fadeInLeft"
          data-josh-duration="1500ms"
        >
          <HMTViewer
            :items="getFloorplanPhotos"
            containerClassName="floorplan__plans-1"
            itemClassName="floorplan__plan"
            imgClassName="floorplan__plan-image"
          >
          </HMTViewer>
        </div>

        <div
          v-if="getFloorplanFiles.length > 0" 
          class="floorplan__files josh-js"
          data-josh-anim-name="fadeInRight"
          data-josh-duration="1500ms"
        >
          <span class="floorplan__files-label">More information</span>

          <div class="floorplan__files-list">
            <a
              v-for="(plan, index) in getFloorplanFiles"
              :key="plan"
              :href="plan" 
              target="_blank"
              class="floorplan__files-item"
            >
              <span class="floorplan__files-item-extension">PDF</span>
              <span class="floorplan__files-item-name">Document {{ index + 1 }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Josh from 'joshjs';

  import HMTViewer from '@/shared/components/VViewer';
  import SectionHeader from '../../components/SectionHeader';

  export default {
    name: 'Floorplan',
    components: {
      SectionHeader,
      HMTViewer
    },
    computed: {
      ...mapGetters('tour', ['getFloorplanPhotos', 'getFloorplanFiles'])
    },
    mounted () {
      // eslint-disable-next-line
      const josh = new Josh();
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .floorplan {
    $self: &;
    
    background-color: var(--primary-section-color);

    &__content {
      @include layoutContent();
      @include layoutHPadding();
      @include layoutVPadding();

      @include lgScreen() {
        padding-bottom: 60px;
      }
    }

    &__container {
      @include lgScreen() {
        display: flex;
      }
    }

    &__plans {
      @include lgScreen() {
        display: flex;
        width: calc(100% - 320px - 30px);
        margin-right: 30px;
      }
    }

    &__plans-1 {
      @include lgScreen() {
        display: flex;
        width: 100%;
      }
    }

    &__plan {
      position: relative;
      padding: 0 10px 20px;
      cursor: pointer;
      transition: transform .2s ease-out;

      @include lgScreen() {
        width: 50%;
      }

      &:hover {
        transform: scale(1.05);
      }

      &-image {
        max-width: 100%;
      }
    }

    &__files {
      background-color: var(--secondary-section-color);
      display: flex;
      padding: 30px;
      flex-direction: column;
      align-self: flex-start;

      @include lgScreen() {
        width: 320px;
      }

      &-label {
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 30px;
      }

      &-item {
        text-decoration: none;
        margin: 0 0 20px;
        display: flex;
        align-items: center;

        &:hover {
          .floorplan__files-item-extension {
            padding-right: 20px;
          }
        }

        &-extension {
          background-color: #ffd800;
          padding: 7px 9px 7px;
          border-radius: 4px;
          margin-right: 10px;
          color: #222;
          font-size: 11px;
          font-weight: 700;
          line-height: 1;
          display: inline-block;
          transition: padding .2s ease-out;
        }

        &-name {
          font-size: 14px;
          font-weight: 400;
          color: #333;
        }
      }
    }
  }
</style>
